/**
 * Capabilities tabs for Data & AI service pages.
 */
export const DATA_AI_CAPABILITIES_EN = [
  {
    id: 'database-management',
    label: 'Database creation & management',
    paragraphs: [
      'We design and manage reliable data infrastructures that ensure your information is structured, secure, and always accessible. From scalable database architectures to optimized storage solutions, every system is built to support performance and long-term growth.',
      'Our approach covers the full data lifecycle, from modeling and integration to maintenance and optimization, providing a solid foundation for analytics, automation, and business intelligence.',
    ],
  },
  {
    id: 'business-intelligence-reporting',
    label: 'Business Intelligence & Reporting',
    paragraphs: [
      'We transform complex data into clear, actionable insights through tailored dashboards, reporting systems, and business intelligence solutions designed around your teams.',
      'By connecting the right data sources and presenting information with clarity and precision, we enable faster decision-making and a deeper understanding of your business performance.',
    ],
  },
  {
    id: 'ai-integrations',
    label: 'AI integrations',
    paragraphs: [
      'We integrate AI capabilities into digital products and business workflows to improve efficiency, automate processes, and unlock new value from existing systems.',
      'From intelligent recommendations to predictive models, our solutions are designed to be scalable, practical, and aligned with real business needs.',
    ],
  },
  {
    id: 'rag-systems',
    label: 'RAG systems',
    paragraphs: [
      'We build Retrieval-Augmented Generation systems that connect large language models with your own trusted data sources, enabling more accurate and context-aware AI outputs.',
      'This approach enhances reliability, reduces hallucinations, and allows teams to search, analyze, and generate information with confidence and control.',
    ],
  },
]

export const DATA_AI_CAPABILITIES_PT = [
  {
    id: 'database-management',
    label: 'Criação e gestão de bases de dados',
    paragraphs: [
      'Desenhamos e gerimos infraestruturas de dados fiáveis que garantem que a informação está estruturada, segura e sempre acessível. De arquiteturas de base de dados escaláveis a soluções de armazenamento otimizadas, cada sistema é criado para suportar performance e crescimento a longo prazo.',
      'A nossa abordagem cobre todo o ciclo de vida dos dados, da modelação e integração à manutenção e otimização, criando uma base sólida para analytics, automação e business intelligence.',
    ],
  },
  {
    id: 'business-intelligence-reporting',
    label: 'Business Intelligence & Reporting',
    paragraphs: [
      'Transformamos dados complexos em insights claros e acionáveis através de dashboards, sistemas de reporting e soluções de business intelligence desenhadas à medida das suas equipas.',
      'Ao ligar as fontes de dados certas e apresentar a informação com clareza e precisão, permitimos decisões mais rápidas e uma compreensão mais profunda da performance do negócio.',
    ],
  },
  {
    id: 'ai-integrations',
    label: 'Integrações de IA',
    paragraphs: [
      'Integramos capacidades de IA em produtos digitais e fluxos de trabalho para melhorar eficiência, automatizar processos e desbloquear novo valor nos sistemas existentes.',
      'De recomendações inteligentes a modelos preditivos, as nossas soluções são desenhadas para serem escaláveis, práticas e alinhadas com necessidades reais de negócio.',
    ],
  },
  {
    id: 'rag-systems',
    label: 'Sistemas RAG',
    paragraphs: [
      'Criamos sistemas Retrieval-Augmented Generation que ligam modelos de linguagem aos seus próprios dados e fontes de conhecimento fiáveis, permitindo respostas de IA mais precisas e contextuais.',
      'Esta abordagem melhora a fiabilidade, reduz alucinações e permite que as equipas pesquisem, analisem e gerem informação com maior confiança e controlo.',
    ],
  },
]
